import KinerjaLayout from 'app/KinerjaPage/components/KinerjaDemoLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PenetapanPredikatKinerja } from 'app/KinerjaPage/pages/PelaksanaanV2/PenilaianKinerja/PenetapanPredikatKinerja'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isPenetapanPenilaianKinerjaEnabled =
      process.env.NEXT_PUBLIC_SKP_FORM_F_ENABLED === 'true'

    if (
      !toggle?.['kinerja-enabled'] ||
      !toggle?.['kinerja-pelaksanaan-enabled'] ||
      !isPenetapanPenilaianKinerjaEnabled ||
      !toggle?.['kinerja-penilaian-demo-mode-enabled']
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {},
    }
  },
})

export default function Page() {
  return <PenetapanPredikatKinerja npsn="demo" />
}

Page.Layout = KinerjaLayout

Page.layoutOpts = { hasHeader: true }
